import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getToken, showToastNotification } from '../../../utility/helper';
import { useAuth } from '@/context/AuthContext';
import type { Permission } from '@/context/permission'
import { RoutesLink } from '@/utility/RouteLinks';


interface ProtectedRouteProps {
    permissions?: string | string[]
    mode?: 'all' | 'any'
    fallbackPath?: string
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    permissions,
    mode = 'all',
    fallbackPath = '/dashboard'
}) => {
    const location = useLocation()
    const token = getToken()
    const { userDetail, hasPermission, isLoading } = useAuth();
    const PUBLIC_ROUTES = [`${RoutesLink.privacyPolicy}`, `${RoutesLink.termsCondation}`, `${RoutesLink.forgetPassword}`];

    if (PUBLIC_ROUTES.includes(location.pathname)) {
        return <Outlet />;
    }
    if (isLoading) {
        return null
    }
    if (!token) {
        return <Navigate to="/" replace />;
    }
    if (userDetail?.role?.name?.toLowerCase() === 'admin') {
        return <Outlet />;
    }
    if (permissions) {
        let ok = false

        if (typeof permissions === 'string') {
            ok = hasPermission(permissions as Permission)
        } else {
            ok =
                mode === 'all'
                    ? permissions.every(p => hasPermission(p as Permission))
                    : permissions.some(p => hasPermission(p as Permission))
        }

        if (!ok) {
            showToastNotification('warning', 'You do not have permission to access this page.')
            return <Navigate to={fallbackPath} state={{ from: location }} replace />
        }
    }

    return <Outlet />;  // Use Outlet instead of children
};

export default ProtectedRoute;